/**
 * Catálogo de iconos de la aplicación.
 *
 * Cada icono se compila como SVG en línea y sólo entra en el paquete final si
 * se usa. La alternativa —cargar la tipografía completa de Material Symbols—
 * añadía 3,8 MB de descarga; esto añade unos cientos de bytes por icono.
 *
 * Para usar un icono nuevo hay que registrarlo aquí. Es deliberado: obliga a
 * mantener un vocabulario visual acotado en vez de acumular variantes.
 */

// Navegación y módulos
import Dashboard from '~icons/material-symbols/dashboard-outline';
import Alarmas from '~icons/material-symbols/notifications-active-outline';
import Sensores from '~icons/material-symbols/sensors';
import Control from '~icons/material-symbols/tune';
import Energia from '~icons/material-symbols/bolt';
import Mapa from '~icons/material-symbols/map-outline';
import Camara from '~icons/material-symbols/videocam-outline';
import Clientes from '~icons/material-symbols/apartment';
import Areas from '~icons/material-symbols/layers-outline';
import Nodos from '~icons/material-symbols/dns-outline';
import Chip from '~icons/material-symbols/memory';
import Actuadores from '~icons/material-symbols/electrical-services';
import Categoria from '~icons/material-symbols/category-outline';
import Medidor from '~icons/material-symbols/electric-meter-outline';
import Umbrales from '~icons/material-symbols/rule';
import Horario from '~icons/material-symbols/schedule-outline';
import Ruta from '~icons/material-symbols/route-outline';
import Usuarios from '~icons/material-symbols/group-outline';
import Contactos from '~icons/material-symbols/contacts-outline';
import Grabador from '~icons/material-symbols/dvr-outline';
import Outbox from '~icons/material-symbols/outbox-outline';
import Webhook from '~icons/material-symbols/webhook';
import Historial from '~icons/material-symbols/history';
import Reporte from '~icons/material-symbols/description-outline';
import Ajustes from '~icons/material-symbols/settings-outline';
import Escalamiento from '~icons/material-symbols/account-tree-outline';
import Llave from '~icons/material-symbols/key-outline';
import Escudo from '~icons/material-symbols/shield-outline';
import Inventario from '~icons/material-symbols/inventory-2-outline';
import Monitoreo from '~icons/material-symbols/monitoring';
import Onda from '~icons/material-symbols/graphic-eq';
import Velocidad from '~icons/material-symbols/speed-outline';

// Acciones
import Menu from '~icons/material-symbols/menu';
// Flecha hacia el margen con su linea: plegar y desplegar la barra lateral.
import PlegarLateral from '~icons/material-symbols/left-panel-close-outline';
import ContraerLateral from '~icons/material-symbols/left-panel-open-outline';
import Cerrar from '~icons/material-symbols/close';
import ChevronDerecha from '~icons/material-symbols/chevron-right';
import ChevronIzquierda from '~icons/material-symbols/chevron-left';
import Expandir from '~icons/material-symbols/expand-more';
import Contraer from '~icons/material-symbols/expand-less';
import Buscar from '~icons/material-symbols/search';
import Agregar from '~icons/material-symbols/add';
import Editar from '~icons/material-symbols/edit-outline';
import Eliminar from '~icons/material-symbols/delete-outline';
import Refrescar from '~icons/material-symbols/refresh';
import Filtrar from '~icons/material-symbols/filter-list';
import Descargar from '~icons/material-symbols/download';
import Subir from '~icons/material-symbols/upload';
import Ver from '~icons/material-symbols/visibility';
import Ocultar from '~icons/material-symbols/visibility-off';
import Candado from '~icons/material-symbols/lock';
import CandadoAbierto from '~icons/material-symbols/lock-outline';
import Salir from '~icons/material-symbols/logout';
import Entrar from '~icons/material-symbols/login';
import TemaClaro from '~icons/material-symbols/light-mode';
import TemaOscuro from '~icons/material-symbols/dark-mode';
import MasOpciones from '~icons/material-symbols/more-vert';
import Atras from '~icons/material-symbols/arrow-back';
import Adelante from '~icons/material-symbols/arrow-forward';
import PrimeraPagina from '~icons/material-symbols/first-page';
import UltimaPagina from '~icons/material-symbols/last-page';
import Anterior from '~icons/material-symbols/navigate-before';
import Siguiente from '~icons/material-symbols/navigate-next';
import Guardar from '~icons/material-symbols/save-outline';
import Copiar from '~icons/material-symbols/content-copy-outline';
import AbrirFuera from '~icons/material-symbols/open-in-new';
import Ayuda from '~icons/material-symbols/help-outline';
import Obra from '~icons/material-symbols/construction';
import Ordenar from '~icons/material-symbols/sort';
import Check from '~icons/material-symbols/check';
import CheckDoble from '~icons/material-symbols/done-all';
import Deshacer from '~icons/material-symbols/undo';
import Enviar from '~icons/material-symbols/send-outline';
import Reproducir from '~icons/material-symbols/play-arrow';
import Detener from '~icons/material-symbols/stop';
import Arrastrar from '~icons/material-symbols/drag-indicator';

// Estados
import Exito from '~icons/material-symbols/check-circle';
import ExitoContorno from '~icons/material-symbols/check-circle-outline';
import Error from '~icons/material-symbols/error';
import ErrorContorno from '~icons/material-symbols/error-outline';
import Advertencia from '~icons/material-symbols/warning';
import AdvertenciaContorno from '~icons/material-symbols/warning-outline';
import Info from '~icons/material-symbols/info';
import InfoContorno from '~icons/material-symbols/info-outline';
import SinConexion from '~icons/material-symbols/cloud-off';
import Conectado from '~icons/material-symbols/cloud-done-outline';
import Vacio from '~icons/material-symbols/inbox-outline';
import SinWifi from '~icons/material-symbols/signal-wifi-off';
import Wifi from '~icons/material-symbols/wifi';
import Circulo from '~icons/material-symbols/circle';
import Pendiente from '~icons/material-symbols/pending-outline';
import Temporizador from '~icons/material-symbols/timer-outline';

// Dominio
import Encender from '~icons/material-symbols/power-settings-new';
import Apagar from '~icons/material-symbols/power-off';
import Pulso from '~icons/material-symbols/flash-on';
import Temperatura from '~icons/material-symbols/thermostat';
import Agua from '~icons/material-symbols/water-drop-outline';
import Puerta from '~icons/material-symbols/sensor-door-outline';
import Bateria from '~icons/material-symbols/battery-full';
import MiUbicacion from '~icons/material-symbols/my-location';
import Ubicacion from '~icons/material-symbols/location-on-outline';
import Pin from '~icons/material-symbols/pin-drop-outline';
import Direcciones from '~icons/material-symbols/directions-outline';
import Cerca from '~icons/material-symbols/near-me-outline';
import Persona from '~icons/material-symbols/person-outline';
import Credencial from '~icons/material-symbols/badge-outline';
import Correo from '~icons/material-symbols/mail-outline';
import Chat from '~icons/material-symbols/chat-outline';
import Mensaje from '~icons/material-symbols/sms-outline';
import Telefono from '~icons/material-symbols/call-outline';
import Calendario from '~icons/material-symbols/calendar-month-outline';
import Reloj from '~icons/material-symbols/schedule';
import Imagen from '~icons/material-symbols/image-outline';
import Foto from '~icons/material-symbols/photo-camera-outline';
import PantallaCompleta from '~icons/material-symbols/fullscreen';
import VistaRejilla from '~icons/material-symbols/grid-view-outline';
import VistaLista from '~icons/material-symbols/view-list-outline';
import VistaTabla from '~icons/material-symbols/table-rows-outline';
import Campana from '~icons/material-symbols/notifications-outline';
import Anuncio from '~icons/material-symbols/campaign-outline';
import SonidoActivo from '~icons/material-symbols/volume-up-outline';
import SonidoMudo from '~icons/material-symbols/volume-off-outline';
import Bandera from '~icons/material-symbols/flag-outline';
import InterruptorOn from '~icons/material-symbols/toggle-on';
import InterruptorOff from '~icons/material-symbols/toggle-off';

export const ICONOS = {
  // Navegación
  dashboard: Dashboard,
  alarmas: Alarmas,
  sensores: Sensores,
  control: Control,
  energia: Energia,
  mapa: Mapa,
  camara: Camara,
  clientes: Clientes,
  areas: Areas,
  nodos: Nodos,
  chip: Chip,
  actuadores: Actuadores,
  categoria: Categoria,
  medidor: Medidor,
  umbrales: Umbrales,
  horario: Horario,
  ruta: Ruta,
  usuarios: Usuarios,
  contactos: Contactos,
  grabador: Grabador,
  outbox: Outbox,
  webhook: Webhook,
  historial: Historial,
  reporte: Reporte,
  ajustes: Ajustes,
  escalamiento: Escalamiento,
  llave: Llave,
  escudo: Escudo,
  inventario: Inventario,
  monitoreo: Monitoreo,
  onda: Onda,
  velocidad: Velocidad,

  // Acciones
  menu: Menu,
  plegarLateral: PlegarLateral,
  contraerLateral: ContraerLateral,
  cerrar: Cerrar,
  chevronDerecha: ChevronDerecha,
  chevronIzquierda: ChevronIzquierda,
  expandir: Expandir,
  contraer: Contraer,
  buscar: Buscar,
  agregar: Agregar,
  editar: Editar,
  eliminar: Eliminar,
  refrescar: Refrescar,
  filtrar: Filtrar,
  descargar: Descargar,
  subir: Subir,
  ver: Ver,
  ocultar: Ocultar,
  candado: Candado,
  candadoAbierto: CandadoAbierto,
  salir: Salir,
  entrar: Entrar,
  temaClaro: TemaClaro,
  temaOscuro: TemaOscuro,
  masOpciones: MasOpciones,
  atras: Atras,
  adelante: Adelante,
  primeraPagina: PrimeraPagina,
  ultimaPagina: UltimaPagina,
  anterior: Anterior,
  siguiente: Siguiente,
  guardar: Guardar,
  copiar: Copiar,
  abrirFuera: AbrirFuera,
  ayuda: Ayuda,
  obra: Obra,
  ordenar: Ordenar,
  check: Check,
  checkDoble: CheckDoble,
  deshacer: Deshacer,
  enviar: Enviar,
  reproducir: Reproducir,
  detener: Detener,
  arrastrar: Arrastrar,

  // Estados
  exito: Exito,
  exitoContorno: ExitoContorno,
  error: Error,
  errorContorno: ErrorContorno,
  advertencia: Advertencia,
  advertenciaContorno: AdvertenciaContorno,
  info: Info,
  infoContorno: InfoContorno,
  sinConexion: SinConexion,
  conectado: Conectado,
  vacio: Vacio,
  sinWifi: SinWifi,
  wifi: Wifi,
  circulo: Circulo,
  pendiente: Pendiente,
  temporizador: Temporizador,

  // Dominio
  encender: Encender,
  apagar: Apagar,
  pulso: Pulso,
  temperatura: Temperatura,
  agua: Agua,
  puerta: Puerta,
  bateria: Bateria,
  miUbicacion: MiUbicacion,
  ubicacion: Ubicacion,
  pin: Pin,
  direcciones: Direcciones,
  cerca: Cerca,
  persona: Persona,
  credencial: Credencial,
  correo: Correo,
  chat: Chat,
  mensaje: Mensaje,
  telefono: Telefono,
  calendario: Calendario,
  reloj: Reloj,
  imagen: Imagen,
  foto: Foto,
  pantallaCompleta: PantallaCompleta,
  vistaRejilla: VistaRejilla,
  vistaLista: VistaLista,
  vistaTabla: VistaTabla,
  campana: Campana,
  anuncio: Anuncio,
  sonidoActivo: SonidoActivo,
  sonidoMudo: SonidoMudo,
  bandera: Bandera,
  interruptorOn: InterruptorOn,
  interruptorOff: InterruptorOff,
} as const;

export type NombreIcono = keyof typeof ICONOS;

/**
 * Iconos ofrecidos al usuario para marcar puntos de interés en el mapa.
 * Es una lista acotada a propósito: elegir de una galería es más rápido y
 * menos propenso a error que escribir el nombre de un icono a mano.
 */
export const ICONOS_PUNTOS_INTERES: readonly NombreIcono[] = [
  'ubicacion',
  'pin',
  'clientes',
  'nodos',
  'energia',
  'agua',
  'escudo',
  'camara',
  'puerta',
  'medidor',
  'temperatura',
  'bandera',
  'persona',
  'inventario',
  'horario',
  'ruta',
];
